import { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/* ── Lucide-style SVG icons ── */
const IC = {
  dashboard: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>,
  gem:       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h12l4 6-10 13L2 9z"/><path d="M11 3 6 9h12L13 3"/><path d="M2 9h20"/></svg>,
  orders:    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12"/></svg>,
  customers: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  mail:      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>,
  search:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  seo:       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>,
  collections:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="9" height="9" rx="1"/><rect x="13" y="3" width="9" height="9" rx="1"/><rect x="2" y="13" width="9" height="5" rx="1"/><rect x="13" y="13" width="9" height="5" rx="1"/></svg>,
  sliders:   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>,
  settings:  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  shield:    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  logout:    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>,
  external:  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3"/></svg>,
  bell:      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
};

const NAV = [
  { path:'/admin',           label:'Dashboard',   icon:'dashboard', exact:true },
  { path:'/admin/gems',        label:'Gems',         icon:'gem' },
  { path:'/admin/collections', label:'Collections',  icon:'collections' },
  { path:'/admin/orders',    label:'Orders',       icon:'orders' },
  { path:'/admin/customers', label:'Customers',    icon:'customers' },
  { path:'/admin/enquiries', label:'Enquiries',    icon:'mail' },
  { path:'/admin/seo',       label:'SEO Manager',  icon:'seo' },
  { path:'/admin/sliders',   label:'Hero Sliders', icon:'sliders' },
  { path:'/admin/settings',  label:'Settings',     icon:'settings' },
  { path:'/admin/users',     label:'Admin Users',  icon:'shield' },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const location  = useLocation();
  const navigate  = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const isActive = (path, exact) => exact ? location.pathname === path : location.pathname.startsWith(path);
  const crumb = NAV.find(n => isActive(n.path, n.exact))?.label || 'Admin Portal';

  return (
    <div className="admin-shell" style={{ display:'flex', minHeight:'100vh', background:'var(--black)', fontFamily:'var(--font-sans)' }}>

      {/* Mobile backdrop */}
      {sideOpen && (
        <div onClick={() => setSideOpen(false)} style={{
          position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', zIndex:999,
          backdropFilter:'blur(2px)',
        }} />
      )}

      {/* ── Sidebar ── */}
      <aside className={`admin-sidebar${sideOpen ? ' open' : ''}`} style={{
        width:72, flexShrink:0,
        background:`linear-gradient(180deg, var(--side-bg) 0%, var(--side-bg-2) 100%)`,
        borderRight:'1px solid var(--side-border)',
        display:'flex', flexDirection:'column', alignItems:'center',
        padding:'18px 0', position:'sticky', top:0, height:'100vh', zIndex:50,
      }}>

        {/* Logo gem tile */}
        <div style={{
          width:42, height:42, borderRadius:10, marginBottom:24, flexShrink:0,
          display:'flex', alignItems:'center', justifyContent:'center',
          background:'radial-gradient(circle at 30% 30%, #2a3974, #0a1240 70%)',
          border:'1px solid rgba(201,169,110,0.3)',
          boxShadow:'inset 0 0 14px rgba(95,141,255,0.45), 0 4px 16px rgba(95,141,255,0.18)',
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3h12l4 6-10 13L2 9z"/><path d="M11 3 6 9h12L13 3"/><path d="M2 9h20"/>
          </svg>
        </div>

        {/* Nav */}
        <nav style={{ display:'flex', flexDirection:'column', gap:4, flex:1, width:'100%', alignItems:'center' }}>
          {NAV.map(({ path, label, icon, exact }) => {
            const active = isActive(path, exact);
            return (
              <div key={path} className="adm-nav-row" style={{ position:'relative', width:'100%', display:'flex', justifyContent:'center' }}>
                <Link to={path} onClick={() => setSideOpen(false)} className={`adm-nav-btn${active ? ' adm-nav-active' : ''}`} style={{
                  width:44, height:44, borderRadius:8,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  color: active ? 'var(--side-text-active)' : 'var(--side-text)',
                  background: active ? 'linear-gradient(180deg, rgba(201,169,110,0.18), rgba(201,169,110,0.08))' : 'transparent',
                  boxShadow: active ? 'inset 0 0 0 1px rgba(201,169,110,0.28)' : 'none',
                  transition:'background 0.18s ease, color 0.18s ease',
                  position:'relative', textDecoration:'none', flexShrink:0,
                }}>
                  {active && (
                    <div className="adm-active-bar" style={{
                      position:'absolute', left:-14, top:10, bottom:10, width:2,
                      background:'linear-gradient(180deg, #e3c98c, #7a5d2c)', borderRadius:2,
                    }} />
                  )}
                  {IC[icon]}
                  <span className="adm-tip" style={{
                    position:'absolute', left:54, top:'50%', transform:'translateY(-50%)',
                    background:'#0c0c10', color:'#fff', padding:'6px 10px', borderRadius:6,
                    fontSize:11, letterSpacing:'0.4px', whiteSpace:'nowrap',
                    border:'1px solid rgba(255,255,255,0.08)', boxShadow:'0 8px 20px rgba(0,0,0,0.4)',
                    opacity:0, pointerEvents:'none', transition:'opacity 0.15s ease', zIndex:60,
                  }}>{label}</span>
                </Link>
              </div>
            );
          })}
        </nav>

        {/* Bottom */}
        <div className="adm-bottom-row" style={{ display:'flex', flexDirection:'column', gap:4, alignItems:'center', paddingTop:8, borderTop:'1px solid var(--side-border)', width:44 }}>
          <button onClick={handleLogout} className="adm-nav-btn adm-logout-btn" title="Sign out" style={{
            width:44, height:44, borderRadius:8,
            display:'flex', alignItems:'center', justifyContent:'center',
            color:'var(--side-text)', transition:'background 0.18s ease, color 0.18s ease',
          }}>
            {IC.logout}
            <span className="adm-tip" style={{
              position:'absolute', left:54, top:'50%', transform:'translateY(-50%)',
              background:'#0c0c10', color:'#fff', padding:'6px 10px', borderRadius:6,
              fontSize:11, whiteSpace:'nowrap', border:'1px solid rgba(255,255,255,0.08)',
              boxShadow:'0 8px 20px rgba(0,0,0,0.4)', opacity:0, pointerEvents:'none',
              transition:'opacity 0.15s ease', zIndex:60,
            }}>Sign out</span>
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div style={{ flex:1, display:'flex', flexDirection:'column', minWidth:0, background:'var(--black)' }}>

        {/* Topbar */}
        <header className="admin-topbar" style={{
          height:64, padding:'0 32px',
          display:'flex', alignItems:'center', justifyContent:'space-between',
          background:'var(--surface)', borderBottom:'1px solid var(--border)',
          position:'sticky', top:0, zIndex:40,
        }}>
          {/* Left — hamburger (mobile) + breadcrumbs */}
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <button onClick={() => setSideOpen(o => !o)} className="adm-hamburger" style={{
              width:36, height:36, borderRadius:8,
              alignItems:'center', justifyContent:'center',
              background:'transparent', border:'1px solid var(--border)',
              color:'var(--muted)', cursor:'pointer', flexShrink:0,
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            </button>
            <div style={{ display:'flex', alignItems:'center', gap:10, color:'var(--muted)', fontSize:12, letterSpacing:'0.5px' }}>
              <span style={{ fontFamily:'var(--font-sans)' }}>Sudath Gems</span>
              <span style={{ color:'var(--border2)' }}>›</span>
              <span style={{ color:'var(--white)', fontWeight:500 }}>{crumb}</span>
            </div>
          </div>

          {/* Right */}
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            {/* Search */}
            <div className="admin-topbar-search" style={{
              display:'flex', alignItems:'center', gap:8,
              background:'var(--surface2)', border:'1px solid var(--border)',
              borderRadius:999, padding:'7px 14px', minWidth:220, color:'var(--muted)',
            }}>
              {IC.search}
              <input placeholder="Search…" style={{
                background:'transparent', border:0, outline:0, flex:1,
                fontSize:13, color:'var(--white)', fontFamily:'var(--font-sans)',
              }} />
            </div>

            {/* View site */}
            <a href="/" target="_blank" rel="noopener noreferrer" className="adm-visit admin-topbar-visit"
              style={{
                display:'inline-flex', alignItems:'center', gap:5,
                fontSize:11, letterSpacing:'1px', textTransform:'uppercase',
                color:'var(--muted)', border:'1px solid var(--border)',
                padding:'7px 12px', borderRadius:999, transition:'all 0.15s',
              }}>
              View site {IC.external}
            </a>

            {/* Bell */}
            <div style={{
              width:36, height:36, borderRadius:'50%',
              display:'flex', alignItems:'center', justifyContent:'center',
              color:'var(--muted)', cursor:'pointer', transition:'var(--transition)',
              position:'relative',
            }}
            onMouseEnter={e=>{e.currentTarget.style.background='var(--surface2)';e.currentTarget.style.color='var(--white)'}}
            onMouseLeave={e=>{e.currentTarget.style.background='transparent';e.currentTarget.style.color='var(--muted)'}}>
              {IC.bell}
            </div>

            {/* Avatar */}
            <div style={{
              width:36, height:36, borderRadius:'50%',
              background:'linear-gradient(135deg, #c9a96e, #7a5d2c)',
              color:'#0c0c10', fontWeight:600, fontSize:13,
              display:'flex', alignItems:'center', justifyContent:'center',
              boxShadow:'0 1px 2px rgba(0,0,0,0.1)',
            }}>
              {admin?.name?.[0]?.toUpperCase() || 'A'}
            </div>
          </div>
        </header>

        {/* Page */}
        <main className="admin-main" style={{ flex:1, overflowY:'auto', padding:'32px 40px' }}>
          <Outlet />
        </main>
      </div>

      <style>{`
        .adm-nav-btn:hover { background: rgba(255,255,255,0.05) !important; color: #fff !important; }
        .adm-nav-btn:hover .adm-tip { opacity: 1 !important; }
        .adm-nav-btn.adm-nav-active:hover { background: linear-gradient(180deg, rgba(201,169,110,0.22), rgba(201,169,110,0.10)) !important; }
        .adm-visit:hover { color: var(--white) !important; border-color: var(--border2) !important; background: var(--surface2) !important; }
        .admin-shell { color: var(--white); }
        .adm-hamburger { display: none; }
        .adm-nav-label { display: none; }
        @media (max-width: 768px) {
          .adm-hamburger { display: flex; }
          .adm-tip { display: none !important; }
          .admin-sidebar {
            position: fixed !important;
            top: 0 !important; left: 0 !important;
            height: 100vh !important;
            z-index: 1001 !important;
            transform: translateX(-100%);
            transition: transform 0.28s ease;
          }
          .admin-sidebar.open { transform: translateX(0) !important; box-shadow: 12px 0 40px rgba(0,0,0,0.7) !important; }
          .adm-nav-btn { width: 52px !important; height: 52px !important; }
          .admin-main { padding: 20px 16px !important; }
          .admin-topbar { padding: 0 16px !important; }
          .admin-topbar-search { display: none !important; }
          .admin-topbar-visit  { display: none !important; }
        }
      `}</style>
    </div>
  );
}
